import { render, staticRenderFns } from "./ClinicalTestResultPSS.vue?vue&type=template&id=41ff0bb6&"
import script from "./ClinicalTestResultPSS.vue?vue&type=script&lang=js&"
export * from "./ClinicalTestResultPSS.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalTestResultPSS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports